<div id="app-container">
  <nav
    (click)="lockScreen()"
    class="navbar navbar-expand-lg custom-sticky-header"
    [class.bg-body-tertiary]="currentTheme !== 'dark'"
  >
    <div
      class="d-flex justify-content-between gap-2 align-items-center w-100 px-2"
    >
      <div class="d-flex gap-2 align-items-center">
        @if (isSubscriptionActive) {
          <!-- @if (!["/pc"].includes(currentRoute)) { -->
          <!--home page show reload option-->
          <!-- <div
           
              (click)="guardTrackerIconClick(true)"
            >
              <i class="fa-solid fa-rotate-right md-font-size"></i>
            </div>
          } @else { -->
          <!--show back btn-->
          <!-- <div
            
              (click)="goBack()"
            >
              <i class="fas fa-angle-left md-font-size"></i>
            </div>
          } -->
          @if (!["/pc"].includes(currentRoute)) {
            <!--home page show reload option-->
            <div (click)="goBack()">
              <i class="fas fa-angle-left md-font-size"></i>
            </div>
          }
        }

        <!-- Logo -->

        <div
          id="gt-logo-home"
          (click)="guardTrackerIconClick()"
          [attr.role]="['/pc'].includes(currentRoute) ? '' : 'button'"
        >
          <img
            src="../../../assets/images/Guard_Tracker-Lateral_Long_{{
              currentTheme
            }}.avif"
            alt="Guard Tracker"
            id="gtLogo"
          />
        </div>
      </div>

      <div class="d-flex gap-3 align-items-center flex-wrap">
        <!-- this button will show up only when a super user access as a normal user. This is like bypassing the authentication-->
        @if (isSuperUserAccess) {
          <button class="btn btn-danger btn-sm" (click)="exitSuperUser()">
            Exit User
          </button>
        }

        @if (
          largeView &&
          isAppOnline &&
          permissionErrorStatus?.message &&
          permissionErrorStatus?.icon === "alert-triangle"
        ) {
          <div
            id="customTooltipBtn"
            class="custom-tooltip"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            [attr.data-bs-original-title]="permissionErrorStatus?.message"
            [gtappGtTooltip]="permissionErrorStatus?.status"
          >
            <i class="fa fa-exclamation-triangle text-danger fa-2x"></i>
          </div>
        }
        <!-- @if (currentRoute !== "/message" && showChatMessageIcon) {
          <div
            [routerLink]="['/message']"
            (click)="unReadMessageCount = 0; navbarToggled = false"
            class="position-relative d-inline-block"
          >
            @if (unReadMessageCount || (notificationCount && isAppOnline)) {
              <span>
                <i
                  class="fa-solid fa-comments fs-5 chat-icon-notification border px-2 border-2 py-1 rounded shadow hover"
                  title="Chat"
                ></i
              ></span>
              <span
                class="badge bg-danger position-absolute top-0 start-50 translate-middle"
              >
                {{ unReadMessageCount + notificationCount }}
              </span>
            } @else {
              <span
                class="border px-2 border-2 pt-3 pb-1 rounded shadow hover"
                id="chatButton"
              >
                <i class="fa-solid fa-comments fs-3" title="Chat"></i
              ></span>
            }
          </div>
        } -->
        <span
          (click)="signOut()"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Sign Out"
        >
          <button class="btn btn-sm btn-outline-secondary">Sign Out</button>
        </span>

        @if (isAppOnline) {
          <div
            id="globalFeedbackbtn"
            (click)="
              openSupportQueryCreateTemplate(supportQueryCreateTemplateRef)
            "
          >
            <i
              class="fa-regular fa-circle-question feedback-icon"
              title="Help"
            ></i>
          </div>
        }
      </div>
    </div>
    @if (isSubscriptionActive && !largeView) {
      <div
        class="d-md-none d-flex small justify-content-center w-100"
        id="statusInfo"
      >
        <!-- status icon to show whether there is background sync by service worker and user offline/online status-->

        <div
          id="customTooltipBtn"
          class="custom-tooltip"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          [attr.data-bs-original-title]="
            permissionErrorStatus?.message
              ? permissionErrorStatus?.message
              : isAppOnline
                ? ''
                : 'Unable to reach server. Operating in offline mode.'
          "
          [gtappGtTooltip]="permissionErrorStatus?.status"
        >
          @if (permissionErrorStatus?.icon === "alert-triangle") {
            <span>
              <i
                class="fa fa-exclamation-triangle text-danger md-font-size"
              ></i>
            </span>
          }

          @if (!permissionErrorStatus?.icon && !isAppOnline) {
            @if (internetConnectionAvailable) {
              <span> <i class="fa fa-wifi text-warning md-font-size"></i></span>
            } @else {
              <span class="small-font text-danger">
                [Working in Offline Mode]
              </span>
            }
          }
        </div>
      </div>
    }
  </nav>

  <div (click)="lockScreen()" id="wrapper">
    <!-- Sidebar -->
    @if (isAppOnline && isSubscriptionActive) {}

    <!-- /#sidebar-wrapper -->

    <!-- Main Content -->
    <div id="page-content-wrapper" (click)="handleWrapperClick($event)">
      <div class="container-fluid pt-lg-2 px-1 p-lg-2">
        @if (!isSubscriptionActive) {
          <div class="alert alert-warning text-center">
            Invalid Subscription
          </div>
        }
        @if (minSupportVersionDevice?.id) {
          <div class="alert alert-warning text-center">
            Outdated browser detected, please update your web browser for the
            best experience.
          </div>
        }

        <div class="my-1 d-flex gap-2 justify-content-end">
          @if (appNewVersionAvailable) {
            <!-- new update available notification-->

            <button
              class="btn btn-success btn-sm"
              (click)="updateGuardTrackerApp()"
            >
              Update App
            </button>
          }
        </div>

        <div>
          <router-outlet></router-outlet>
        </div>

        @if (windowScrolled && currentRoute !== "/message") {
          <div
            class="scroll-up"
            (click)="scrollToTop(); $event.stopImmediatePropagation()"
          >
            <i class="fa-solid fa-angles-up fa-4x text-secondary"></i>
          </div>
        }
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>
</div>
<ng-template #supportQueryCreateTemplateRef let-feedbackRef="dialogRef">
  <div class="card dialog-box p-1 pb-2">
    <div class="card-header">
      Help

      <span
        class="float-end"
        (click)="
          feedbackRef.close('close'); showHideDraggableFeedbackBtn(false)
        "
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="p-1 mb-3">
      <form [formGroup]="feedbackForm" class="row-cols-1 gy-2">
        <div class="col form-group input-group">
          <textarea
            class="form-control"
            cols="32"
            rows="5"
            wrap="hard"
            maxlength="340"
            placeholder="Need help or have feedback? Please tell us how we can help."
            formControlName="feedback"
            id="updateCommentBox"
          ></textarea>
          @if (feedbackForm.value.feedback) {
            <span
              class="input-group-text"
              (click)="clearAndFocusTextBox('updateCommentBox')"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      </form>
    </div>

    <!-- <div class="p-1 mb-2 small">
              @if(feedbackAttachment?.fileUrl){
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <img src="{{ feedbackAttachment?.fileUrl }}" width="200" />
                  </div>
                  <div>
                    <button
                      type="button"
                      class="btn btn-outline-danger"
                      (click)="feedbackAttachment = {}"
                      >
                      Delete Photo
                    </button>
                  </div>
                </div>

                }@else {
                <div>
                  <button
                    class="btn btn-outline-primary btn-sm"
                    (click)="attachImageToQuery()"
                    >
                    Add Photo (Optional)
                  </button>
                  <span class="small text-secondary">
                    Add an image so that we can understand you better</span
                    >
                  </div>
                }
              </div> -->

    <div class="d-flex gap-1 mb-4">
      <div id="buttons" class="d-flex gap-2 mx-auto">
        <button
          (click)="
            feedbackRef.close('close'); showHideDraggableFeedbackBtn(false)
          "
          class="btn btn-secondary btn-md w-100 h-100"
        >
          Cancel
        </button>

        @if (existingSupportQueries) {
          <button
            class="btn btn-outline-success btn-md w-100 h-100"
            [routerLink]="['/support']"
            (click)="
              feedbackRef.close('close'); showHideDraggableFeedbackBtn(false)
            "
          >
            Support Inquiries
          </button>
        }

        <button
          (click)="
            addfeedback();
            feedbackRef.close();
            showHideDraggableFeedbackBtn(false)
          "
          class="btn btn-primary btn-md w-100 h-100"
          [disabled]="!feedbackForm.valid"
        >
          Submit
        </button>
      </div>
    </div>
    <div
      id="debugTools"
      class="d-flex flex-wrap justify-content-between align-items-center mb-1 flex-lg-row flex-column"
    >
      <div id="info" class="px-3 py-0 small text-secondary">
        <div>
          {{ userCurrentDeviceDetail?.time | customDate: "d MMM y HH:mm" }}
          {{ userCurrentDeviceDetail?.timeZone }}
          @if (userCurrentDeviceDetail?.gps?.lat) {
            <span>
              @if (userCurrentDeviceDetail?.os?.toLowerCase() === "ios") {
                <a
                  class="text-decoration-none text-secondary hover"
                  [href]="
                    'https://maps.apple.com?q=' +
                    userCurrentDeviceDetail?.gps?.lat +
                    ',' +
                    userCurrentDeviceDetail?.gps?.lon
                  "
                  target="_blank"
                >
                  {{ userCurrentDeviceDetail?.gps?.lat?.toFixed(5) }},
                  {{ userCurrentDeviceDetail?.gps?.lon?.toFixed(5) }}
                </a>
              } @else {
                <a
                  class="text-decoration-none text-secondary hover"
                  [href]="
                    'https://www.google.com/maps/search/?api=1&query=' +
                    userCurrentDeviceDetail?.gps?.lat +
                    ',' +
                    userCurrentDeviceDetail?.gps?.lon
                  "
                  target="_blank"
                >
                  {{ userCurrentDeviceDetail?.gps?.lat?.toFixed(5) }},
                  {{ userCurrentDeviceDetail?.gps?.lon?.toFixed(5) }}
                </a>
              }
            </span>
          }
        </div>
        <div>
          {{ userCurrentDeviceDetail?.deviceType }}
          {{ userCurrentDeviceDetail?.device }}
          {{ userCurrentDeviceDetail?.os }}
          {{ userCurrentDeviceDetail?.os_version }}
          {{ userCurrentDeviceDetail?.browser }}
          {{ userCurrentDeviceDetail?.browser_version }}
        </div>
      </div>

      <div
        role="button"
        class="border py-1 px-3 rounded border-4 text-center mb-lg-0 my-2 hover"
        (click)="
          feedbackRef.close('close');
          showHideDraggableFeedbackBtn(false);
          clearAllDataAndReload()
        "
      >
        Clear Cache
      </div>
    </div>
  </div>
</ng-template>
